import React from "react";
import { hiddenCosts } from "../data/salesContent";
export function CostComparison() {
  return <section aria-labelledby="costo" className="w-full bg-cream py-16 lg:py-24" data-id="element-34" data-mp="2aw7j3418d1ol">
      <div className="mx-auto max-w-5xl px-5" data-id="element-35" data-mp="26umahuvqb9k7">
        <h2 id="costo" className="text-center font-display text-3xl font-black text-ink sm:text-5xl" data-id="element-36" data-mp="26vdue8fyriun">
          ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mt-12 grid overflow-hidden rounded-3xl border border-cream-deep bg-white md:grid-cols-[1.4fr_1fr]" data-id="element-37" data-mp="2yls2fo1aq0ye">
          <div className="p-7 sm:p-10" data-id="element-38" data-mp="2ulhxmep8pgl4">
            <h3 className="font-display text-lg font-extrabold text-muted" data-id="element-39" data-mp="2uic6yv0yq6na">Sin MegaPack</h3>
            <dl className="mt-4 divide-y divide-cream-deep" data-id="element-40" data-mp="2pjiw7ad28tqt">
              {hiddenCosts.map(c => <div key={c.label} className="flex items-baseline justify-between gap-4 py-4" data-id="element-41" data-mp="2kodaabjnrf2q">
                  <dt className="text-ink" data-id="element-42" data-mp="1e7hyh5y7xuyx">{c.label}</dt>
                  <dd className="shrink-0 font-display font-extrabold text-danger" data-id="element-43" data-mp="196u9eptjvo7c">{c.cost}</dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-4 pt-5" data-id="element-44" data-mp="2lbkdbm2iceg2">
                <dt className="font-display text-lg font-extrabold text-ink" data-id="element-45" data-mp="2pb2z0k25ktjy">Total oculto</dt>
                <dd className="font-display text-3xl font-black text-danger" data-id="element-46" data-mp="2bbjt7xwtduat">$1.500+</dd>
              </div>
            </dl>
          </div>
          <div className="flex flex-col items-center justify-center bg-ink p-10 text-center" data-id="element-47" data-mp="2gdslst5ryuce">
            <h3 className="font-display text-lg font-extrabold text-cream" data-id="element-48" data-mp="21kp32igg6ak3">Con MegaPack</h3>
            <p className="mt-2 font-display text-7xl font-black text-gold" data-id="element-49" data-mp="26etcd8d6quoc">$17</p>
            <p className="mt-3 max-w-[16rem] text-cream/70" data-id="element-50" data-mp="1sneux5yxf1je">
              Una sola vez. Menos de lo que pierdes en una torta fallida.
            </p>
          </div>
        </div>
      </div>
    </section>;
}